import { LoyaltyDomainError, LoyaltyDomainSpecificErrorCode } from '../types/error';
export function assertIsMemberSignedIn(member, message) {
    if (!member) {
        throw new LoyaltyDomainError(LoyaltyDomainSpecificErrorCode.NoSignedInMember, `${message}. No member is signed in.`);
    }
}
//# sourceMappingURL=assert-is-member-signed-in.js.map